// extracted by mini-css-extract-plugin
module.exports = {"inputRoot":"DateRangeController_inputRoot__yo8ec","arrowIcon":"DateRangeController_arrowIcon__1HlZ7"};